import { RollingType } from 'types/GlobalKpiOption'
import { ShowPerEnum } from 'types/GlobalMetric'

import { TDataDialogSource, TDataDialogView } from './types'

// The metric identity + labels the chat anchors to. Shared by every source so
// the chat is built the same way regardless of where the dialog was opened.
export type TActiveMetricView = {
  metricId: string
  variantKpiTemplateId: string | null
  rollingSum: RollingType | null
  distribution: ShowPerEnum | null
  slices: string[]
  title: string
  unit: string | null
}

// The view the dialog currently displays: an explicit selection wins,
// otherwise the source's initial view (or the first one when no initial id
// is given). An initial id that matches no view selects nothing.
export const getActiveView = (
  source: TDataDialogSource | null,
  selectedViewId: string | null
): TDataDialogView | null => {
  if (!source) return null

  if (selectedViewId) {
    return source.views.find((view) => view.id === selectedViewId) ?? null
  }

  if (source.initialId) {
    return source.views.find((view) => view.id === source.initialId) ?? null
  }

  return source.views[0] ?? null
}

// The metric identity to anchor the chart/chat to, or null when the view has
// no metric anchor (details-only views).
export const getActiveMetricView = (
  view: TDataDialogView | null
): TActiveMetricView | null => {
  if (!view?.metric) return null

  return {
    metricId: view.metric.id,
    variantKpiTemplateId: view.metric.settings.variant_kpi_template_id,
    rollingSum: view.metric.settings.rolling_sum,
    distribution: view.metric.settings.distribution,
    slices: view.metric.settings.slices,
    title: view.title,
    unit: view.unit
  }
}
